module.exports = __webpack_public_path__ + "img/image0.c59f3a9.png";